import React from "react";
import { SEO, MainLayout, EditCard } from "../../../../components";

const ProEditCardPage = () => {
  return (
    <>
      <SEO title="edit card" />
      <MainLayout>
        <EditCard />
      </MainLayout>
    </>
  );
};

export default ProEditCardPage;
